// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_PatientOptions_New_ReferralSource($location_id: uuid!) {
  vaxiom_referral_templates(
    where: {
      _and: [
        { location: { _id: { _eq: $location_id } } }
        { deleted: { _eq: false } }
      ]
    }
  ) {
    id
    type
    text: free_type
    referral_list_values {
      id: pos
      text: value
    }
  }
}

`